import { useState } from "react";
import "./css/DonationQr.css";

const CopyIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  </svg>
);

const CheckIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

const ShareIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3"></circle>
    <circle cx="6" cy="12" r="3"></circle>
    <circle cx="18" cy="19" r="3"></circle>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
  </svg>
);

const DownloadIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

// const QR_IMAGE_URL = "https://d28w88on64rtni.cloudfront.net/samyak_sankalp_qr_code.png";
const UPI_ID = "8319436955m@pnb";

function CopyButton({ text }) {
  const [copied, setCopied] = useState(false);
  const handle = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    });
  };
  return (
    <button onClick={handle} className={`qr-donation-copy-btn ${copied ? "copied" : ""}`}>
      {copied ? <CheckIcon /> : <CopyIcon />}
      {copied ? "Copied!" : "Copy"}
    </button>
  );
}

function ShareQRButton() {
  const [status, setStatus] = useState("idle"); // idle | shared | downloaded

  const handleShare = async () => {
    // Try Web Share API first (mobile)
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Veer Samyak Sankalp Foundation — UPI QR",
          text: `Donate via UPI: ${UPI_ID}`,
          url: '/images/samyak_sankalp_qr_code.png',
        });
        setStatus("shared");
        setTimeout(() => setStatus("idle"), 2000);
      } catch (err) {
        // User cancelled — do nothing
      }
    } else {
      // Fallback: download the QR image
      const link = document.createElement("a");
      link.href = '/images/samyak_sankalp_qr_code.png';
      link.download = "samyak-upi-qr.png";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setStatus("downloaded");
      setTimeout(() => setStatus("idle"), 2000);
    }
  };

  return (
    <button onClick={handleShare} className="qr-donation-share-btn">
      {status === "shared" ? (
        <><CheckIcon /> Shared!</>
      ) : status === "downloaded" ? (
        <><CheckIcon /> Downloaded!</>
      ) : (
        <>
          {navigator.share ? <ShareIcon /> : <DownloadIcon />}
          {navigator.share ? "Share QR" : "Download QR"}
        </>
      )}
    </button>
  );
}

export default function DonationQr() {
  const [showQr, setShowQr] = useState(false);  // 👈 add this

  return (
    <div className="customcontainer">
      <div className="qr-donation-wrapper">
        <div className="qr-donation-card">

          {/* Header */}
          <div className="qr-donation-header">
            <div>
              <div className="qr-donation-header-pre">Be a Partner in Change.</div>
              <div className="qr-donation-header-title">Veer Samyak Sankalp Foundation</div>
            </div>
          </div>

          {/* Body */}
          <div className="qr-donation-body">

            {/* LEFT — Quote */}
            <div className="qr-donation-right">
              <div className="qr-donation-quote-box">
                <div className="qr-donation-quote-mark">"</div>
                <p className="qr-donation-quote-text">
                  Veer Samyak Foundation is a registered non-profit organization. Every contribution is handled with the highest standard of accountability.
                </p>
                <div className="qr-donation-quote-mark bottom">"</div>
              </div>
            </div>

            {/* RIGHT — QR Code */}
            <div className="qr-donation-left">
              <div className="qr-donation-section-title">UPI / QR Payment</div>

              <div className="qr-donation-qr-box">

                {/* <img
                  className="qr-donation-qr-img"
                  src={QR_IMAGE_URL}
                  alt="QR Code"
                /> */}

                <button
                  onClick={() => setShowQr(prev => !prev)}
                  className="qr-donation-share-btn"
                >
                  {showQr ? "Hide QR Code" : "Show QR Code"}
                </button>

                <div className="qr-donation-qr-container" style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap:"1rem", minHeight:'350px' }}>
                  {showQr && (


                    <>
                      {/* <div className="qr-donation-upi-label">Scan to Pay</div> */}
                      <img
                        className="qr-donation-qr-img"
                        src={'/images/samyak_sankalp_qr_code.png'}
                        alt="QR Code"
                        style={{ minHeight: "250px" }}
                      />



                      {/* UPI ID + Copy */}
                      <div className="qr-donation-upi-row">
                        <span className="qr-donation-upi-id">{UPI_ID}</span>
                        <CopyButton text={UPI_ID} />
                      </div>

                      {/* Share / Download QR */}
                      <ShareQRButton />
                    </>

                  )}
                </div>



              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}